import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AwardIcon, CheckCircle2Icon, MapPinIcon, PhoneIcon, ShieldCheckIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { company } from '../../data/company';
import type { TranslationKey } from '../../data/translations';
const badges: {
  icon: typeof AwardIcon;
  key: TranslationKey;
}[] = [{
  icon: AwardIcon,
  key: 'hero.badge1'
}, {
  icon: ShieldCheckIcon,
  key: 'hero.badge2'
}, {
  icon: CheckCircle2Icon,
  key: 'hero.badge3'
}, {
  icon: MapPinIcon,
  key: 'hero.badge4'
}];
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section className="relative isolate overflow-hidden bg-navy" aria-labelledby="hero-title" data-id="element-278" data-mp="10lfijq4k19fe">
      <img src={company.heroImage} alt={t('hero.imageAlt')} className="absolute inset-0 h-full w-full object-cover" width={1600} height={900} data-id="element-279" data-mp="10n9wgkhes19z" />
      <div className="absolute inset-0 bg-navy/75" aria-hidden="true" data-id="element-280" data-mp="1ah8rz0mz8msy" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-transparent" aria-hidden="true" data-id="element-281" data-mp="9pdv9ptx66ga" />

      <div className="relative mx-auto max-w-page px-4 py-20 sm:px-6 md:py-28 lg:px-8 lg:py-32" data-id="element-282" data-mp="4qsvfrikxosd">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="max-w-3xl" data-id="element-283" data-mp="3vx3ph3p69pa7">
          <a href={company.phoneHref} className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-sm font-semibold text-white ring-1 ring-inset ring-white/25 transition-colors duration-150 ease-smooth hover:bg-white/20" data-id="element-284" data-mp="sg532my9dosk">
            <PhoneIcon className="h-4 w-4 text-cta-light" aria-hidden="true" data-id="element-285" data-mp="ekt6ea0jlo90" />
            {t('hero.callNow')}: {company.phone}
          </a>

          <h1 id="hero-title" className="mt-6 font-display text-[2.1rem] font-extrabold leading-[1.1] tracking-tight text-white sm:text-5xl lg:text-[3.55rem]" data-id="element-286" data-mp="16djutybzi8np">
            {t('hero.h1')}
          </h1>

          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-white/85 md:text-xl" data-id="element-287" data-mp="35kh32kcws4tt">{t('hero.sub')}</p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-288" data-mp="2qvuctnlqtsnt">
            <Link to="/#contact" className="inline-flex items-center justify-center rounded-md bg-cta px-7 py-4 text-base font-bold text-white shadow-lg transition-colors duration-200 ease-smooth hover:bg-cta-dark" data-id="element-289" data-mp="2vufgxy448whj">
              {t('cta.scheduleInspection')}
            </Link>
            <Link to="/#projects" className="inline-flex items-center justify-center rounded-md border-2 border-white/80 px-7 py-4 text-base font-bold text-white transition-colors duration-200 ease-smooth hover:bg-white hover:text-navy" data-id="element-290" data-mp="27yt53v0t1eg6">
              {t('cta.viewWork')}
            </Link>
          </div>

          <ul className="mt-12 grid gap-x-8 gap-y-4 sm:grid-cols-2" data-id="element-291" data-mp="1vn0kvckzwyq0">
            {badges.map(({
            icon: Icon,
            key
          }) => <li key={key} className="flex items-center gap-3 text-sm font-semibold text-white sm:text-base" data-id="element-292" data-mp="1qop8ov78ac4m">
                <Icon className="h-5 w-5 shrink-0 text-brand-300" aria-hidden="true" data-id="element-293" data-mp="25dvfb48eb4mj" />
                {t(key)}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}